


export const REQUEST_AUTH_CODE = {
    SUCCESS: 200,
    UNAUTHORIZED: 401,      //token异常 或者无权限
    BE_REPLACED: -4,      //token 被定下线
    KICK_OUT: -5 ,      //token 踢下线
    NOT_AUTH: 400,      //无权限
    NOT_LOGIN: 409,      //未登录
    NOT_VISIT:5001,     //无访问权限
    OPT_MOST:2000,     //操作过于频繁
};


export const REQUEST_MESSAGE = {
    ERROR: "服务不可用,请稍后重试",
    TOKEN_EXPIRE: "会话过期,请重新登录",
    BE_REPLACED: "你的账号在另一处登录,你已被顶下线!",
    KICK_OUT: "你的账号已被踢下线!",
};
